<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/b6FRuF/tc-custom/9780743434126.jpg?1730526156022" alt="This image is the cover for the book Heat, Fearless"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Heat, Fearless
      </h1>
      <p class="bookDescription body article font2">
        <p>Everyone longs for something. <br/> And everyone gives in to temptation sometimes. <br/> Mary. <br/> Heather. <br/> Sam. <br/> Now it's my turn.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Francine Pascal
      </h2>
      
      <p class="authorDescription body article">Francine Pascal is the creator of several bestselling series, including Fearless and Sweet Valley High, which was also made into a television series. She has written several novels, including <I>My First Love and Other Disasters</I>, <I>My Mother Was Never a Kid</I>, and <I>Love &amp; Betrayal &amp; Hold the Mayo</I>. She is also the author of <I>Sweet Valley Confidential: Ten Years Later</I>. She lives in New York and the South of France.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Simon Pulse
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?22316486